import React from "react";
import posed from "react-pose";
import random from "lodash/random";
import { easeInOut } from "@popmotion/easing";
import SplitText from "react-pose-text";

export const genRandomTopX = () => random(-200, 200, false);

export const AnimatedText = (props) => (
  <SplitText
    charPoses={{
      exit: { opacity: 0, y: 20 },
      enter: {
        opacity: 1,
        y: 0,
        delay: ({ charIndex }) => charIndex * 30,
      },
    }}
    initialPose="exit"
    pose="enter"
    {...props}
  />
);

export const AnimatedRandomX = posed.span({
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      opacity: {
        duration: 5000,
        ease: easeInOut,
      },
      y: () => ({
        type: "keyframes",
        values: [
          0,
          genRandomTopX(),
          genRandomTopX(),
          genRandomTopX(),
          genRandomTopX(),
          genRandomTopX(),
          genRandomTopX(),
          0,
        ],
        duration: random(20, 40, true) * 1000,
        ease: easeInOut,
        loop: Infinity,
      }),
    },
  },
  exit: {
    opacity: 0,
    y: 0,
  },
});

const FadeInPose = posed.span(({ duration } = { duration: 2000 }) => ({
  enter: {
    opacity: 1,
    transition: {
      opacity: { duration },
    },
  },
  exit: {
    opacity: 0,
  },
}));

export const FadeIn = (props) => (
  <FadeInPose initialPose="exit" pose="enter" {...props} />
);
